module.exports = __webpack_public_path__ + "img/logo.4e5b6f5c.svg";